import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';

export default component$(
  ({ cssClasses }: { cssClasses: string }): JSX.Element => {
    return (
      <svg
        class={cssClasses}
        width='16'
        height='16'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 64 64'
      >
        <title>Image Credit Icon</title>
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 26'>
          <g data-name='Layer 2'>
            <g data-name='Layer 1'>
              <circle cx='16' cy='15' r='5'></circle>
              <path d='M29.09,4.33H23.27L20.36,0H11.64L8.73,4.33H2.91A2.9,2.9,0,0,0,0,7.22V23.11A2.9,2.9,0,0,0,2.91,26H29.09A2.9,2.9,0,0,0,32,23.11V7.22A2.9,2.9,0,0,0,29.09,4.33ZM16,22a7,7,0,1,1,7-7A7,7,0,0,1,16,22Z' />
            </g>
          </g>
        </svg>
      </svg>
    );
  }
);
